import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { pickBy } from 'lodash';
import { AuthService } from 'src/app/_services/auth.service';
import { CompanyService } from 'src/app/_services/company.service';
import { FilesControlService } from 'src/app/_services/files-control.service';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css'],
})
export class HistoryComponent implements OnInit, OnChanges {
  private readonly companyScopeId = 1075;
  private isCompany1075 = false;

  operations: [] = [];
  users: [] = [];

  selectedOperations;
  selectedUsers;

  tableData: any = [];
  page = 1;
  pageSize = 0;
  collectionSize = 0;

  isLoading;
  filters;

  @Input() id;

  constructor(
    public filesControlService: FilesControlService,
    public companyService: CompanyService,
    public authService: AuthService
  ) {}

  ngOnInit() {
    this.resolveCompanyScope();

    if (this.id) {
      this.refreshData();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // This reactive reload is only enabled for company 1075.
    if (this.isCompany1075 && changes.id && changes.id.currentValue) {
      this.page = 1;
      this.refreshData();
    }
  }

  private resolveCompanyScope() {
    const token = localStorage.getItem('token');
    if (!token) {
      this.isCompany1075 = false;
      return;
    }

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      this.isCompany1075 = Number(payload?.idCompany) === this.companyScopeId;
    } catch {
      this.isCompany1075 = false;
    }
  }

  refreshData() {
    if (!this.id) {
      this.tableData = [];
      this.collectionSize = 0;
      this.isLoading = false;
      return;
    }

    this.isLoading = true;
    this.filesControlService
      .getFileHistoryById(
        this.page,
        { ...this.filters, id: this.id },
        this.pageSize
      )
      .subscribe((res) => {
        this.collectionSize = res.body['total'];
        this.tableData = res.body['results'];
        this.page = res.body['page'];
        this.isLoading = false;
      });
  }

  setFilters() {
    const filters = {
      operation:
        this.selectedOperations?.length > 1
          ? [this.selectedOperations]
          : this.selectedOperations,
      user:
        this.selectedUsers?.length > 1
          ? [this.selectedUsers]
          : this.selectedUsers,
    };
    this.filters = {
      ...filters,
    };
    this.filters = pickBy(this.filters, (v) => v !== undefined);
    this.page = 1;
    this.refreshData();
  }

  cleanFilters() {
    this.selectedOperations = undefined;
    this.selectedUsers = undefined;
    this.filters = undefined;
    this.filters = {
      ...this.filters,
    };
    this.filters = pickBy(this.filters, (v) => v !== undefined);
    this.page = 1;
    this.refreshData();
  }
}
